import { type SelectInputProps, SelectInput } from "react-admin";

import { usePaymentProviderModels } from "../api";

export const PaymentProviderInput = (
  props: Omit<SelectInputProps, "choices" | "isPending">,
) => {
  const { isPending, data: { paymentProviderModelsList = [] } = {} } =
    usePaymentProviderModels();

  return (
    <SelectInput
      {...props}
      isPending={isPending}
      choices={paymentProviderModelsList}
    />
  );
};
